<mat-dialog-content class="d-flex flex-col">
    <div class="flex-row flex-space-between">
        <div>
            <mat-card-header class="p-0">
                <mat-card-title>
                    <h3 class="m-0" mat-dialog-title>Leave Feedback</h3>
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();" aria-label="Close window"
                    class="mat-dialog-close"
                    mat-dialog-close mat-icon-button
                    matTooltip="Close Window">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <form [formGroup]="feedbackForm" class="pt-10 flex-col">
        <mat-form-field appearance="outline">
            <mat-label>Feedback Title</mat-label>
            <input formControlName="title" matInput required>
            @if (feedbackForm.controls['title'].hasError('required')) {
                <mat-error>A title is required</mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea formControlName="description" matInput maxlength="400"
                      required></textarea>
            @if (feedbackForm.controls['description'].hasError('required')) {
                <mat-error>A description is required</mat-error>
            }
        </mat-form-field>
        <div class="d-flex flex-space-around">

        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="flex-row flex-space-between w-100">
        <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();" class="mat-elevation-z2"
                color="warn" mat-dialog-close
                mat-raised-button
                matTooltip="Cancel flag">
            Cancel
        </button>
        <button (click)="submit()" (keyup.enter)="submit()" [attr.aria-busy]="loading" [disabled]="loading"
                class="mat-elevation-z2" color="primary" mat-raised-button
                matTooltip="Submit feedback">
            Submit
        </button>
    </div>
</mat-dialog-actions>

